import json2csv from 'json2csv'

export default class Csvhelper {
  constructor (headers) {
    this.headers = headers
  }
  createFileURL (dataArray, fields) {
    let createDataUriFromString = (str) => {
      var bom = new Uint8Array([0xEF, 0xBB, 0xBF])
      var blob = new Blob([ bom, str ], { 'type': 'text/csv' })
      return window.URL.createObjectURL(blob)
    }
    const csv = json2csv({ data: dataArray, fields: fields, fieldNames: this.headers })
    return createDataUriFromString(csv)
  }
}
